import { render, staticRenderFns } from "./partnership.vue?vue&type=template&id=424a8ffa&scoped=true&"
import script from "./partnership.vue?vue&type=script&lang=js&"
export * from "./partnership.vue?vue&type=script&lang=js&"
import style0 from "./partnership.vue?vue&type=style&index=0&id=424a8ffa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "424a8ffa",
  null
  
)

export default component.exports